import React from 'react'
import NavigationSidebar from '../../containers/NavigationSidebar'
import AppNotification from 'views/components/AppNotification/AppNotification'
import styles from './ContentWithNavigationSidebar.css'

const ContentWithNavigationSidebar = props => {
  const {
    children,
    sidebarIsCollapsed,
  } = props

  const contentClassName = sidebarIsCollapsed ? 'contentWithSidebarCollapsed' : 'content'

  return (
    <div className={styles.root}>
      <AppNotification />
      <NavigationSidebar />
      <div className={styles[contentClassName]}>
        {children}
      </div>
    </div>
  )
}

export default ContentWithNavigationSidebar



// WEBPACK FOOTER //
// ./src/legacy/layouts/ContentWithNavigationSidebar/ContentWithNavigationSidebar.jsx